import ToolBase from '../basic';
import DEFINE from '../define';

export default class HorizonLine extends ToolBase {

    name = DEFINE.TOOLS.HORIZON_LINE;

    setting = null;
    horizonLine = null;
    isDown = null;
    origX = null;
    origY = null;

    constructor(parent) {
        super(parent);
    }

    recover(object) {
        object.set({
            lockMovementX: true,
            lockMovementY: true,
            hasControls: false,
            hasBorders: false
        })
    }

    mouseUp(o) {
        this.isDown = false;

        if(!this.isMove) {
            this.canvas.remove(this.horizonLine)
            this.canvas.renderAll();
        }else {
            this.parent.addHistory();
        }
    }

    mouseDown(o) {
        this.setting = this.parent.getDrawSetting(DEFINE.DRAW_TYPE.LINE_SEGMENT);
        let pointer = this.getLimitPointer(this.canvas.getPointer(o.e));

        this.isDown = true;

        this.isMove = false;

        this.origX = pointer.x - this.setting.strokeWidth * 0.5;
        this.origY = pointer.y - this.setting.strokeWidth * 0.5;
        this.horizonLine = new fabric.Line([this.origX, this.origY, this.origX, this.origY], {
            tag: DEFINE.TAG.HORIZON_LINE + new Date().getTime(),
            toolType: this.name,
            opacity: this.setting.opacity,
            fill: this.setting.fill,
            stroke: this.setting.stroke,
            strokeWidth: this.setting.strokeWidth,
            strokeLineCap: "round",
            transparentCorners: false,
            selectable: true,
            hasControls: false,
            hasBorders: false,
            lockMovementX: true,
            lockMovementY: true,
            perPixelTargetFind: true,
        });
        this.canvas.add(this.horizonLine);
    }

    mouseMove(o) {
        if (!this.isDown) return;
        let pointer = this.getLimitPointer(this.canvas.getPointer(o.e));

        this.horizonLine.set({
            x2: pointer.x - this.setting.strokeWidth * 0.5
        });

        this.horizonLine.setCoords();
        this.canvas.renderAll();

        this.isMove = true;
    }
}